export const APP_RESOURCES_REQUEST = 'permissions/APP_RESOURCES_REQUEST';
export const APP_RESOURCES_SUCCESS = 'permissions/APP_RESOURCES_SUCCESS';
export const APP_RESOURCES_FAILURE = 'permissions/APP_RESOURCES_FAILURE';
export const APP_ACTIONS_REQUEST = 'permissions/APP_ACTIONS_REQUEST';
export const APP_ACTIONS_SUCCESS = 'permissions/APP_ACTIONS_SUCCESS';
export const APP_ACTIONS_FAILURE = 'permissions/APP_ACTIONS_FAILURE';
export const APP_SETTINGS_REQUEST = 'permissions/APP_SETTINGS_REQUEST';
export const APP_SETTINGS_SUCCESS = 'permissions/APP_SETTINGS_SUCCESS';
export const APP_SETTINGS_FAILURE = 'permissions/APP_SETTINGS_FAILURE';
